import script from "./CookiesBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CookiesBanner.vue?vue&type=script&setup=true&lang=js"

import "./CookiesBanner.vue?vue&type=style&index=0&id=7de5fe08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de5fe08"]])

export default __exports__